import { apiClient } from "../../../base/ApiClient";


export const searchClients = async (query) => {
  const response = await apiClient.get(`/client/clients/search-sms/?q=${query}`);
  return response.data;
};